export default "        .pos 0\ninit:   irmovl stack,%esp\n        halt\n\n        .pos 0x200\nstack:\n";